import { EMAIL_REGEX } from '@core/modules/issues/constants'

export const normalizeEmail = (value?: string): string => (value ?? '').trim()

export const isValidEmail = (value?: string): boolean =>
    EMAIL_REGEX.test(normalizeEmail(value))
